import {downloadCsv} from '~/lib/file';

export type ICSVColumn<T> = keyof T;

interface ICSVProps<T> {
    records: T[];
    columns: ICSVColumn<T>[];
}

export class CSV<T> {
    constructor(private props: ICSVProps<T>) {
    }

    static fromDataSource<T>(records: T[], columns: (keyof T)[]): CSV<T> {
        return new CSV({
            records: records,
            columns: columns
        });
    }

    toCSVValue(value: any) {
        if (typeof value === 'string') {
            let pattern = new RegExp(/[",]/);
            return value.replace(pattern, token => `\/${token}`);
        } else if (!value) {
            return '';
        }
        return value;
    }

    generate() {
        let data = [];
        let {columns, records} = this.props;
        // Insert column labels
        data.push(columns);
        // Insert records labels
        return data.concat(records.map(record =>
            columns.map(column => this.toCSVValue(record[column])).join(',')
        )
        ).join('\n');
    }

    download(filename: string = 'export.csv') {
        downloadCsv(filename, this.generate());
    }
}
